import * as React from "react";
import Home from "../Home/Home";
import '../Home/Home.css';
// import axios from "axios";
import CopilotChatbot from "../Home/CopilotChatbot";

interface AppProps {
  siteURL: string;
  tokenvalue: string;
  currentUser: any;
  clearLocalStorage:any;
}
  const Main: React.FC<AppProps> = ({siteURL, tokenvalue, currentUser,clearLocalStorage}) => {
  const CopilotLogo: any = require('../../../../assets/CopilotLogo.png');
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}");
 const [isAppOpen,setIsAppOpen]=React.useState(true);
 const [chatbotVisible, setChatbotVisible] = React.useState(false);
  const [copilotConfig, setCopilotConfig] = React.useState<any>(Copilot);

//  React.useEffect(()=>{
//     getAppUsers()
//  },[])
//  const getAppUsers=async()=>{
//   const url = "/_api/web/lists/getbytitle('CLM365Users')/items?$select=*,GuidID,SPUser/Title,SPUser/ID,SPUser/EMail&$expand=SPUser";

//   try {
//       const response = await axios.get(`${siteURL}${url}`, {
//           headers: {
//             Accept: "application/json;odata=nometadata",
//             "odata-version": "",
//             Authorization: `Bearer ${tokenvalue}`,
//           },
//         });
//         if (response?.status === 401) {
//           clearLocalStorage(); 
       
//         } else {
//           setIsAppOpen(true);
//         }
//         // if (response.status!== 200) {
//         //   checkTokenExpiration(response.status)
          
//         // }


//         // // const items=response?.data.value||[];
//         // const items=response?.data.value||[];
//         // const allUsersOptions=[]
//         // items?.map((user)=>{
//         //   allUsersOptions.push({
//         //       key: user.email,
//         //       text: user?.SPUser?.Title,
//         //       id: user?.SPUser?.ID,
//         //       userStatus:user?.UserStatus
//         //   })
//         // })

//         //   const currentUserExist=allUsersOptions?.filter(user=>user.key?.toLowerCase()==currentUser?.currentUserEmail?.toLowerCase()&& user?.userStatus != 'Inactive');

//         //  if(currentUserExist?.length==0){
//         //   checkTokenExpiration('UserNotExistInApp')
//         //  }else{
//         //   setIsAppOpen(true);
//         //  }

   
    
    
  
//   } catch (error) {
//     if (error?.status === 401) {
//       clearLocalStorage(); 
   
//     }
//     // if(error?.status){
//     //   checkTokenExpiration(error.status)
//     // }
//      console.log(error)
//   }
//  }
 React.useEffect(() => {
    const setItem = localStorage?.setItem;
    localStorage.setItem = function (k, v) {
      setItem?.apply(this, [k, v]);
      if (k === "Copilot") {
        setCopilotConfig(JSON.parse(v || "{}"));
      }
    };
    return () => {
      localStorage.setItem = setItem;
    };
  }, []);
  return (
    <div id="tasPaneComponent" >
    {copilotConfig?.CopilotToggle === 'Yes' && <div className="Chatbot-button">
      <img src={CopilotLogo} alt="Copilot" width={30} height={30} onClick={() => setChatbotVisible(true)} style={{marginLeft: '5px'}}/>
    </div>}
     { isAppOpen?<Home siteURL={siteURL} tokenvalue={tokenvalue} currentUser={currentUser} />:null}
      {chatbotVisible && (
       <div className="Chatbot">
        <CopilotChatbot setChatbot={setChatbotVisible} />
        </div>
       )} 
    </div>


  );
};

export default Main;
